import React, { useEffect, useState } from "react";
import { ColorPicker } from "primereact/colorpicker";
import { fetchHomeJsonList, saveThemeJsonData } from "../../../redux/Actions";
import { useDispatch, useSelector } from "react-redux/es/exports";

function SectionThemeFourEditor() {
  const [editedHeaderData, setHeaderJsonData] = useState<any>();
  const dispatch = useDispatch<any>();
  const jsonData: any = useSelector<any>((state) => state.homeJsonList);

  const handleHeaderChange = (e: any, val?: any) => {
    const { value, name } = e.target;
    let sectiondata: any = [...editedHeaderData?.theme_4?.home.sections];
    if (val !== undefined) {
      sectiondata = editedHeaderData?.theme_4?.home.sections.map((v: any) => {
        if (v._id === val._id) {
          return {
            ...v,
            is_section_enable: !v.is_section_enable,
          };
        } else {
          return v;
        }
      });
    }
    setHeaderJsonData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_4:{
        home: {
          ...prevJsonData.theme_4.home,
          sections: sectiondata,
          header: {
            ...prevJsonData.theme_4.home.header,
            [name]: value,
            nav: {
              ...prevJsonData.theme_4.home.header.nav,
            },
            btn_group: {
              ...prevJsonData.theme_4.home.header.btn_group,
            },
          },
        },
      }
     
    }));
  };

  const saveHeaderJsonDataToFile = () => {
    dispatch(fetchHomeJsonList(editedHeaderData));
    dispatch(saveThemeJsonData(editedHeaderData));
  };

  useEffect(() => {
    if (editedHeaderData != undefined) {
      setHeaderJsonData(editedHeaderData);
    }
  }, [editedHeaderData]);

  useEffect(() => {
    setHeaderJsonData(jsonData);
  }, [jsonData]);

  return (
    <>
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Header Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              <h4 className="edit-section-hdr">Theme Color</h4>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Primary Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="primary_color"
                        value={editedHeaderData?.theme_4?.home?.header?.primary_color}
                        onChange={handleHeaderChange}
                        maxLength={250}
                      />
                      <ColorPicker
                        name="primary_color"
                        onChange={(e) => {
                          handleHeaderChange(e);
                        }}
                        format="hex"
                        value={editedHeaderData?.theme_4?.home?.header?.primary_color}
                      />
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Secondary Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="secondary_color"
                        value={editedHeaderData?.theme_4?.home?.header?.secondary_color}
                        onChange={handleHeaderChange}
                        maxLength={250}
                      />
                      <ColorPicker
                        name="secondary_color"
                        onChange={(e) => {
                          handleHeaderChange(e);
                        }}
                        format="hex"
                        value={editedHeaderData?.theme_4?.home?.header?.secondary_color}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <h4 className="edit-section-hdr">Sections</h4>
              <div className="row">
                <div className="col">
                  <ul className="section-list">
                    {Array.isArray(editedHeaderData?.theme_4?.home?.sections) &&
                      editedHeaderData?.theme_4?.home?.sections.map(
                        (section: any, index: any) => (
                          <li key={index}>
                            <div className="section-show">
                              <span className="sectioninput">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name="is_section_enable"
                                  id={section._id}
                                  onClick={(e) =>
                                    handleHeaderChange(e, section)
                                  }
                                  checked={section.is_section_enable}
                                />
                              </span>
                              <img src={section.icon} alt="" />
                            </div>
                          </li>
                        )
                      )}
                  </ul>
                </div>
              </div>
            </div>

            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={() => {
                  saveHeaderJsonDataToFile();
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SectionThemeFourEditor;
